/*
 *   File :  viewMessageContent.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description : Message content
 *   Integrations :
 *   Version : v1.0
 */

/*import packages*/
import React, { useState, useEffect } from 'react';

import styles from '../../styles/components/viewMessageUser.module.scss';
import { SecondaryBtn, PrimaryBtn } from '../cta';
import { DataTable } from '../dataFormating';


export default function ViewTemplateInstructions(props) {



    return (
        <div className={`${styles.e_view_content} modal fade`}
            id={"view-instructions"}
            tabIndex="-1"
            data-bs-backdrop="static"
            aria-labelledby="view-message-instructions"
            aria-hidden="true">
            <div className={`${styles.e_modal_dialog} modal-dialog modal-dialog-centered`}>
                <div className={`${styles.e_content} modal-content p-4`}>
                    <h5 className='mt-3'>General Template Writing Tips</h5>
                    <ul>
                        <li>
                            <b>Keep your message under 450 characters</b> for Utility and Marketing
                            templates to avoid rejection.
                        </li>
                        <li>
                            <b>Use no more than 10 emojis</b> in a template. Too many emojis may lead
                            to rejection.
                        </li>
                        <li>
                            <b>Keep it short and clear</b> – avoid unnecessary details.
                        </li>
                        <li>
                            Don’t submit templates with only variables or unclear structure.
                        </li>
                        <li>
                            Avoid using the word <b>"survey"</b>; ask for feedback instead.
                        </li>
                    </ul>

                    <div className='col-12 text-center'>
                        <PrimaryBtn name="Okay" cancel="modal" />
                    </div>
                </div>

            </div>
        </div>
    )
}